// extracted by mini-css-extract-plugin
module.exports = {"opaque":"_-web-client-js-react-components-___WTFPrincipalListField-module__opaque___2yXcv"};